import { useEffect, useState } from 'react';
import { useSettings } from '@/contexts/SettingsContext';
import { cn } from '@/lib/utils';

/**
 * شعار الموقع من الإعدادات، ولو مفيش شعار (أو فشل تحميله) يظهر اسم الموقع بخط أنيق.
 * imgClassName: مقاس الصورة، textClassName: مقاس الاسم.
 */
const BrandLogo = ({ className, imgClassName = 'h-12 w-auto', textClassName = 'text-2xl', onClick, light = false }) => {
  const { logo_url, site_name } = useSettings();
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [logo_url]);

  if (logo_url && !failed) {
    return (
      <img
        src={logo_url}
        alt={site_name}
        onClick={onClick}
        onError={() => setFailed(true)}
        className={cn('object-contain', imgClassName, className)}
      />
    );
  }

  return (
    <span
      onClick={onClick}
      className={cn(
        'inline-block font-tajawal font-extrabold leading-none tracking-tight whitespace-nowrap max-w-[14rem] truncate py-1',
        light ? 'text-white' : 'text-burgundy-500',
        textClassName,
        className
      )}
    >
      {site_name}
    </span>
  );
};

export default BrandLogo;
